// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__6pDFk","header_right":"styles_header_right__37opA","header_left":"styles_header_left__2B_7H"};